import { CandidateInfoPage } from '@pages/candidate';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Профиль кандидата', 'Профиль кандидата');
}

export default CandidateInfoPage;
